import { api } from './index'
import { unwrap } from './client'
import type { components } from './schema'

export type EnterpriseBinding = components['schemas']['EnterpriseBinding']

/** Where Google sends the admin's browser when signup ends, and why. */
export type CallbackStatus = 'bound' | 'error'
export type CallbackReason =
  'invalid_state' | 'expired_state' | 'in_progress' | 'google_rejected' | 'google_unavailable'

export interface SignupUrl {
  url: string
  expires_at: string
}

/** Binding state. Needs `devices.read`, so every tenant role can read it. */
export async function fetchBinding(tenantId: string): Promise<EnterpriseBinding> {
  return unwrap<EnterpriseBinding>(
    await api.GET('/api/v1/tenants/{tenant}/enterprise', {
      params: { path: { tenant: tenantId } },
    }),
  )
}

/**
 * Asks Google for a signup URL. Needs `enterprise.manage`, and answers 409 with
 * `errors.code[0] === 'already_bound'` when the tenant is bound already — which
 * is what a double-clicked start button produces, not a failure.
 */
export async function createSignupUrl(tenantId: string): Promise<SignupUrl> {
  return unwrap<SignupUrl>(
    await api.POST('/api/v1/tenants/{tenant}/enterprise/signup-url', {
      params: { path: { tenant: tenantId } },
    }),
  )
}
